import { Key01, Mail05, Users01 } from "@untitledui/icons";
import { useState } from "react";
import { useAdminInvites } from "@/api/admin/invites";
import { useAdminUsers } from "@/api/admin/users";
import { usePagination } from "@/api/pagination";
import { Tabs } from "@/components/application/tabs/tabs";
import { useDebounce } from "@/hooks/use-debounce";
import { InviteUserModal } from "@/pages/admin/modals/invite-user";
import { PageHeader } from "@/pages/admin/page-header";
import { AdminInvitesTable } from "@/pages/admin/tables/invites";
import { AdminUsersTable } from "@/pages/admin/tables/users";

const tabs = [
  { id: "active", label: "Active", icon: <Key01 /> },
  { id: "invited", label: "Invited", icon: <Mail05 /> },
];

export const UsersPage = () => {
  const [selectedTab, setSelectedTab] = useState<string>("active");
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search);
  const pagination = usePagination();

  const { data: usersData } = useAdminUsers(
    pagination.pagination,
    { column: "createdAt", direction: "desc" },
    { text: "" },
  );
  const { data: invitesData } = useAdminInvites(
    pagination.pagination,
    { column: "createdAt", direction: "desc" },
    { text: "" },
  );

  const isActiveTab = selectedTab === "active";
  const count = isActiveTab ? usersData?.total : invitesData?.total;

  return (
    <div className="h-full flex flex-col gap-6 mt-4 px-12">
      <PageHeader
        title="Users"
        subtitle={"All Users with access to our application"}
        count={count}
        search={search}
        onSearchChange={setSearch}
        actions={<InviteUserModal />}
        icon={Users01}
      />
      <Tabs selectedKey={selectedTab} onSelectionChange={(key) => setSelectedTab(key as string)}>
        <Tabs.List type="underline" items={tabs}>
          {(tab) => <Tabs.Item {...tab} />}
        </Tabs.List>
      </Tabs>
      <div className="flex-1 min-h-0 flex flex-col overflow-auto">
        {isActiveTab ? <AdminUsersTable search={debouncedSearch} /> : <AdminInvitesTable search={debouncedSearch} />}
      </div>
    </div>
  );
};
